import React from 'react';
import { css } from '@emotion/react';
import { InjectableSVG } from '@core/svg';
import { CUSTOM_ASSET } from '@player/testIds';
/**
 * Component to wrap custom assets (icons).
 *
 * @param props
 * @returns
 */
const CustomAsset = (props) => {
    const { src } = props;
    return (<InjectableSVG data-testid={CUSTOM_ASSET} src={src} useRequestCache={true} wrapper="div" css={css `
        width: 100%;
        height: 100%;

        > div {
          width: 100%;
          height: 100%;

          > svg {
            width: 100%;
            height: 100%;
          }
        }
      `}/>);
};
/**
 * Helper to decide whether to return injected SVG or src string. If the asset is an SVG, it will be injected,
 * otherwise src string will be returned. By injecting SVG into the DOM we can style it with CSS (currentColor).
 */
export function customAssetOrSrc(src) {
    return src && src.toLowerCase().search('.svg') ? (<CustomAsset src={src}/>) : (src);
}
